<template lang="html">
  <v-layout column>
    <v-flex xs12>
      <!-- <h3 class="display-2">หมวดหมู่</h3>
      <h3 class="display-2">Categories</h3> -->
      <v-card color="grey darken-4" class="white--text">
        <v-card-title>
          <div>
            <h3 class="mb-0" style="font-size:26px">หมวดหมู่/Categories</h3>
          </div>
        </v-card-title>
      </v-card>
    </v-flex>

    <v-flex xs12>
      <v-card>
        <v-container grid-list-lg fluid>
          <v-layout row wrap>
            <v-flex xs12>
                <v-divider></v-divider>

                <v-list dense>
                  <v-list-tile
                    v-for="item in items"
                    :key="item.title"
                    :to="{ name: item.name}"
                  >
                    <v-list-tile-action>
                      <v-icon>{{ item.icon }}</v-icon>
                    </v-list-tile-action>

                    <v-list-tile-content>
                      <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-flex>

    <v-flex xs12>
      <v-layout column>
        <v-flex xs12>
          <h3>สินค้าแนะนำ</h3>
          <v-divider></v-divider>
        </v-flex>
        <v-flex xs12 v-for="(value,i) in popular_product" :key="i">
          <v-card flat>
            <v-layout row wrap>
              <v-flex xs3>
                <v-avatar size="65px">
                  <v-img
                    v-if="value.url === ''"
                    :src="require('@/assets/no-product.png')"
                    :lazy-src="require('@/assets/no-product.png')"
                    aspect-ratio="1"
                    max-height="200"
                    contain
                    class="white"
                  >
                    <v-layout
                      slot="placeholder"
                      fill-height
                      align-center
                      justify-center
                      ma-0
                    >
                      <v-progress-circular indeterminate color="blue darken-4"></v-progress-circular>
                    </v-layout>
                  </v-img>
                    <v-img
                      v-else
                      :src="value.url"
                      :lazy-src="value.url"
                      aspect-ratio="1"
                      max-height="200"
                      contain
                      class="white"
                    >
                      <v-layout
                        slot="placeholder"
                        fill-height
                        align-center
                        justify-center
                        ma-0
                      >
                        <v-progress-circular indeterminate color="blue darken-4"></v-progress-circular>
                      </v-layout>
                    </v-img>
                </v-avatar>
              </v-flex>
              <v-flex xs6>
                <v-layout column>
                  <v-flex xs12>
                    <div>
                      {{ value.name }}
                      <v-subheader>{{ value.code }}</v-subheader>
                    </div>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs3>
                <div class="text-xs-center">
                  <product-dialog
                    :data="value"
                    check="small">
                  </product-dialog>
                </div>

                <!-- <v-btn flat icon color="indigo">
                  <v-icon>add</v-icon>
                </v-btn> -->
                  <!-- <v-btn fab dark small color="indigo">
                    <v-icon dark>add</v-icon>
                  </v-btn> -->
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
      <!-- <h3>สินค้าแนะนำ</h3>
      <p>....</p>
      <p>....</p>
      <p>....</p>
      <p>....</p> -->
    </v-flex>
  </v-layout>

</template>

<script>
import ProductDialog from './productDialog.vue'
export default {
  components: {
    ProductDialog
  },
  props: ['popular_product'],
  data () {
    return {
      items: [
        {title: 'สินค้าแนะนำ', icon: 'star', name: 'popularProduct'},
        { title: 'เปลเด็ก & เตียงเด็ก', icon: 'shopping_cart', name: 'cradlesProduct' },
        { title: 'ชั้นวาง', icon: 'shopping_cart', name: 'shelvesProduct' },
        { title: 'โต๊ะ & เก้าอี้', icon: 'shopping_cart', name: 'tableSandSeatsProduct' },
        { title: 'ราว', icon: 'shopping_cart', name: 'racksProduct' },
        { title: 'ชั้นรองเท้า', icon: 'shopping_cart', name: 'beddingsProduct' },
        { title: 'ชั้นงานไม้', icon: 'shopping_cart', name: 'woodProduct' },
        { title: 'อื่นๆ', icon: 'shopping_cart', name: 'otherProduct' }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/categoriesCard.vue